import { useCallback, useState, useEffect } from 'react';
    import useApi from './useApi';

    export const useDashboards = (userId) => {
        const [dashboards, setDashboards] = useState([]);
        const [categories, setCategories] = useState([]);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);

        const { callApi: fetchDashboardsApi } = useApi(
            `https://vision.alfama.com/api/view/usuarios/dashboard/${userId}`,
            { includeToken: true }
        );

        const handleToggleFavorite = (dashboardId, novoEstado) => {
            setDashboards(prev =>
                prev.map(dash =>
                    dash.dashboard_id === dashboardId
                        ? { ...dash, is_favorito: novoEstado ? 1 : 0 }
                        : dash
                )
            );
        };

        const groupDashboards = useCallback((dashboardList) => {
            const groupedData = dashboardList.reduce((acc, item) => {
                const category = item.nome_categoria_departamento || "Outros";
                const subCategory = item.nome_departamento || "Outros";

                if (!acc[category]) acc[category] = {};
                if (!acc[category][subCategory]) {
                    acc[category][subCategory] = {
                        id: item.departamento_id,
                        dashboards: [],
                    };
                }

                acc[category][subCategory].dashboards.push({
                    id: item.dashboard_id,
                    label: item.nome_dashboard,
                    description: item.descricao_dashboard,
                    path: `/relatorio/${item.link_id}`,
                    is_homologado: item.is_homologado,
                    is_favorito: item.is_favorito === 1,
                });
                return acc;
            }, {});

            setCategories(
                Object.entries(groupedData).map(([name, subcategories]) => ({
                    name,
                    subcategories
                }))
            );
        }, []);

        const fetchDashboards = useCallback(async () => {
            if (!userId) {
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);
                const response = await fetchDashboardsApi();
                if (response) {
                    setDashboards(response);
                    groupDashboards(response);
                }
            } catch (err) {
                console.error("Erro ao carregar dashboards:", err);
                setError("Não foi possível carregar os dashboards.");
            } finally {
                setLoading(false);
            }
        }, [userId, fetchDashboardsApi, groupDashboards]);

        const getFavoriteDashboards = useCallback(() => {
            return dashboards
                .filter((d) => d.is_favorito === 1)
                .map((d) => ({
                    id: d.dashboard_id,
                    label: d.nome_dashboard,
                    description: d.descricao_dashboard,
                    path: `/relatorio/${d.link_id}`,
                    is_homologado: d.is_homologado,
                    is_favorito: true,
                }));
        }, [dashboards]);

        useEffect(() => {
            fetchDashboards();
        }, [fetchDashboards]);

        return {
            dashboards,
            categories,
            loading,
            error,
            handleToggleFavorite,
            fetchDashboards,
            getFavoriteDashboards
        };
    };